import SchoolImage1 from "../../../assets/images/png/business/schools/data.webp";
import SchoolImage5 from "../../../assets/images/png/business/schools/engineering.webp";
import SchoolImage2 from "../../../assets/images/png/business/schools/product-marketing.webp";
import SchoolImage4 from "../../../assets/images/png/business/schools/product.webp";
import SchoolImage3 from "../../../assets/images/png/business/schools/project-mgt.webp";
import SchoolImage6 from "../../../assets/images/png/business/schools/security.webp";

import CourseImage2 from "../../../assets/images/png/business/courses/course1.webp";
import CourseImage4 from "../../../assets/images/png/business/courses/course4.webp";
import CourseImage5 from "../../../assets/images/png/business/courses/course5.webp";
import CourseImage6 from "../../../assets/images/png/business/courses/course6.webp";
import CourseImage1 from "../../../assets/images/png/business/courses/course7.webp";
import CourseImage3 from "../../../assets/images/png/business/courses/course8.webp";

export const businessSchoolData = [
  {
    id: 1,
    bgColor: "#050794",
    name: "Data Science",
    image: SchoolImage1,
    imageSmall: CourseImage1,
    brochureLink:
      "https://drive.google.com/file/d/1HIHmz4NmBs4NQfHCapmzuTBhn-NC2zS6/view?usp=sharing",
    description:
      "Utiva Data Science School is designed to shape you to the best you can be in your current role or transitioning to a new career. We have the best & experience trainers to help you on that journey.",
  },
  {
    id: 2,
    bgColor: "#0C8F54",
    name: "Product Marketing",
    image: SchoolImage2,
    imageSmall: CourseImage2,
    brochureLink:
      "https://drive.google.com/file/d/1OH6YAgXHefMei9-n9u5NlOVWnSHbjRny/view?usp=sharing",
    description:
      "Utiva Product Marketing School is designed to shape you to the best you can be in your current role or transitioning to a new career. We have the best & experience trainers to help you on that journey.",
  },
  {
    id: 3,
    bgColor: "#7C01A7",
    name: "Project Management",
    seoTitle: `Project Management Course Online Africa | Utiva`,
    metatags: `Get certified in project management with Utiva's practical, industry-led training. Learn Agile, PMP frameworks, and stakeholder management. Enrol from anywhere in Africa.`,
    image: SchoolImage3,
    imageSmall: CourseImage3,
    brochureLink:
      "https://drive.google.com/file/d/1kkzTUmk4gQwU0QgkE6v6u6LJ5ba0HOBy/view?usp=sharing",
    description:
      "Utiva Project Management School is designed to shape you to the best you can be in your current role or transitioning to a new career. We have the best & experience trainers to help you on that journey.",
  },
  {
    id: 4,
    bgColor: "#A78700",
    name: "Product Management",
    image: SchoolImage4,
    imageSmall: CourseImage4,
    brochureLink:
      "https://drive.google.com/file/d/17hbOpFFwEflPDaSfHQNJOGx_PVxWHrcm/view",
    description:
      "Utiva Product Management School is designed to shape you to the best you can be in your current role or transitioning to a new career. We have the best & experience trainers to help you on that journey.",
  },
  {
    id: 5,
    bgColor: "#A74F46",
    name: "Software Engineering",
    image: SchoolImage5,
    imageSmall: CourseImage5,
    brochureLink:
      "https://drive.google.com/file/d/18QBBE3-wWt2muV6uhaiy5W_YW35sbJVE/view?usp=sharing",
    description:
      "Utiva Software Engineering School is designed to shape you to the best you can be in your current role or transitioning to a new career. We have the best & experience trainers to help you on that journey.",
  },
  {
    id: 6,
    bgColor: "#0E8F8F",
    name: "Cybersecurity",
    image: SchoolImage6,
    imageSmall: CourseImage6,
    brochureLink:
      "https://drive.google.com/file/d/1UOZC-GzZSH5CV2sxRTvN_vceIHonKNA6/view?usp=sharing",
    description:
      "Utiva Cybersecurity School is designed to shape you to the best you can be in your current role or transitioning to a new career. We have the best & experience trainers to help you on that journey.",
  },
];
